export const CART_ITEM_ADD = 'CART_ITEM_ADD';
export const CART_ITEM_REMOVE = 'CART_ITEM_REMOVE';
export const CART_ITEM_SAVE_SHIPPING = 'CART_ITEM_SAVE_SHIPPING';
export const CART_ITEM_SAVE_PAYMENT = 'CART_ITEM_uSAVE_PAYMENT';
export const CART_ITEM_REMOVE_ALL = 'CART_ITEM_REMOVE_ALL';
export const CART_ITEM_REMOVE_SHIPPING = 'CART_ITEM_REMOVE_SHIPPING';
